import React, { useEffect, useState } from 'react';

/**
 * Square image with reserved aspect-ratio skeleton until load/error.
 */
export default function SkeletonImage({
    src,
    alt = '',
    className = '',
    frameClassName = '',
    loading = 'lazy',
}) {
    const [ready, setReady] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setReady(false);
        setFailed(false);
    }, [src]);

    return (
        <span
            className={[
                'gs-skeleton-frame',
                frameClassName,
                ready ? 'is-ready' : '',
                failed ? 'is-failed' : '',
            ].filter(Boolean).join(' ')}
        >
            {!ready && !failed && (
                <span className="gs-skeleton-shimmer" aria-hidden="true" />
            )}
            {!failed && src ? (
                <img
                    src={src}
                    alt={alt}
                    loading={loading}
                    className={className}
                    onLoad={() => setReady(true)}
                    onError={() => {
                        setFailed(true);
                        setReady(true);
                    }}
                />
            ) : null}
            {failed && (
                <span className="gs-skeleton-fallback" aria-hidden="true" />
            )}
        </span>
    );
}
